import React, { forwardRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';

const DrawSignature = forwardRef((_, ref) => {
    return <SignatureCanvas penColor="black" canvasProps={{ width: 500, style: { height: '100%' } }} ref={ref} />;
});

export default DrawSignature;
